import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import type {
  GetNotificationsRequest,
  GetNotificationsCountRequest,
  NotificationsRequest,
  NotificationsResponse,
  GetNotificationsResponse,
  GetNotificationsCountResponse,
} from "@ServerTypes/notifications/notifications.schema";
import {
  setNotificationsData,
  setUnreadNotificationsCount,
  setShowNotification,
  readNotificationsData,
  unreadNotificationsData,
  setNotificationsStatusesData,
} from "../reducers/notification";

export {
  setNotificationsData,
  setUnreadNotificationsCount,
  setShowNotification,
  readNotificationsData,
  unreadNotificationsData,
  setNotificationsStatusesData,
};

export async function getNotifications(newCountRequired = 4, oldCountRequired = 4) {
  const data: GetNotificationsRequest = {
    value: {
      source: "header",
      newNotificationsFilter: {
        notificationType: ["NOTIFICATION_UNREAD"],
        requiresCounts: false,
        limit: newCountRequired,
      },
      previousNotificationsFilter: {
        notificationType: ["NOTIFICATION_READ"],
        requiresCounts: false,
        limit: oldCountRequired,
      },
    },
  };

  try {
    const response = await axiosWrapper.post<GetNotificationsResponse>(
      `${getBackendUrl()}/notifications/getNotifications`,
      data,
    );
    return response.data;
  } catch (err) {
    console.log(err);
    Promise.reject(err);
  }
}

export function getNotificationsCount(filterType: GetNotificationsCountRequest["filter"]) {
  const data: GetNotificationsCountRequest = {
    filter: filterType,
  };
  return async (dispatch: AppDispatch) => {
    try {
      const response = await axiosWrapper.post<GetNotificationsCountResponse>(
        `${getBackendUrl()}/notifications/getNotificationsCount`,
        data,
      );

      if (response.data.status) {
        dispatch(setUnreadNotificationsCount(response.data.data));
      }
    } catch (err) {
      console.log(err);
      Promise.reject(err);
    }
  };
}

export async function readNotification(idsArr: NotificationsRequest["ids"]) {
  const data: NotificationsRequest = {
    ids: idsArr,
  };

  try {
    const response = await axiosWrapper.post<NotificationsResponse>(
      `${getBackendUrl()}/notifications/dismissNotification`,
      data,
    );

    return response.data.status;
  } catch (err) {
    console.log(err);
    Promise.reject(err);
  }
}

export async function unreadNotification(idsArr: NotificationsRequest["ids"]) {
  const data: NotificationsRequest = {
    ids: idsArr,
  };

  try {
    const response = await axiosWrapper.post<NotificationsResponse>(
      `${getBackendUrl()}/notifications/unreadNotification`,
      data,
    );

    return response.data.status;
  } catch (err) {
    console.log(err);
    Promise.reject(err);
  }
}
